import React, { useEffect, useState } from 'react';
import { bool, func } from 'prop-types';

import ImageSimulationBuy from '@assets/Image/Trading/AutoOrder/ATO-simulation-buy.png';
import ImageSimulationSell from '@assets/Image/Trading/AutoOrder/ATO-simulation-sell.png';

import { Container, MessageBox, Tab, Typography } from '@ajaibid/components';
import { PopUpCenterV2 } from 'Component/PopUp';

import { useStockBuySellContext } from '../hooks';

const TAB_OPTIONS = [
  { key: 'BUY', name: 'Auto Order Beli' },
  { key: 'SELL', name: 'Auto Order Jual' },
];

const CONTENTS = {
  BUY: {
    img: ImageSimulationBuy,
    description:
      'Auto Order Beli dapat mengirimkan order beli saham secara otomatis berdasarkan kriteria tertentu. Lewat Auto Order Beli, kamu bisa mengeksekusi strategi Buy on Strength dan Buy on Weakness dengan mudah.',
    infoTitle: 'Harga Mencapai',
    infoText:
      'Harga Mencapai merupakan syarat Auto Order Buy berdasarkan kriteria lebih dari atau kurang dari harga yang kamu inginkan. Saat Auto Order Buy aktif dan syarat ini terpenuhi, Ajaib akan mengirim order beli secara otomatis.',
  },
  SELL: {
    img: ImageSimulationSell,
    description:
      'Auto Order Sell dapat mengirimkan order jual saham secara otomatis berdasarkan kriteria tertentu. Lindungi profit saham dan batasi kerugianmu dengan fitur ini.',
    infoTitle: 'Harga Mencapai',
    infoText:
      'Harga Mencapai merupakan syarat pengiriman Auto Order Sell berdasarkan kriteria lebih dari atau kurang dari harga saham di pasar. Saat Auto Order Sell aktif dan syarat ini terpenuhi, Ajaib akan mengirim order jual secara otomatis.',
  },
};

const PopUpAutoSimulation = (props) => {
  const { show, onHide } = props;

  const { formState, formKey } = useStockBuySellContext();
  const [activeTab, setActiveTab] = useState(TAB_OPTIONS[0]);

  const resetState = () => {
    const tab = TAB_OPTIONS?.find((v) => v.key === formState?.[formKey.INPUT_ORDER_SIDE]);
    setActiveTab(tab || TAB_OPTIONS[0]);
  };

  useEffect(() => {
    // If formState is changed, update state to match formState
    resetState();
  }, [formState]);

  const handleHide = () => {
    resetState();
    onHide();
  };

  return (
    <PopUpCenterV2
      size="lg"
      show={show}
      onHide={handleHide}
      title="Simulasi Auto Order"
      data-testid="popup-autoSimulation"
    >
      <Tab
        tabOptions={TAB_OPTIONS}
        activeTab={activeTab}
        setActiveTab={(v) => setActiveTab(v)}
        style={{ marginTop: 8 }}
        data-testid="tab-orderSide"
      />
      <Container padding="16px 0px">
        <img
          src={CONTENTS[activeTab?.key]?.img}
          alt=""
          style={{ height: 270 }}
          data-testid="img-simulation"
        />
        <Typography type="body" align="left" data-testid="txt-description">
          {CONTENTS[activeTab?.key]?.description}
        </Typography>
        {(CONTENTS[activeTab?.key]?.infoTitle || CONTENTS[activeTab?.key]?.infoText) && (
          <MessageBox
            type="info"
            title={CONTENTS[activeTab?.key]?.infoTitle}
            text={CONTENTS[activeTab?.key]?.infoText}
            style={{ marginTop: 16 }}
            data-testid="msg-thresholdDefinition"
          />
        )}
      </Container>
    </PopUpCenterV2>
  );
};

PopUpAutoSimulation.propTypes = {
  show: bool,
  onHide: func,
};

PopUpAutoSimulation.defaultProps = {
  show: false,
  onHide: () => {},
};

export default PopUpAutoSimulation;
